// eslint-disable-next-line
import React, { useState, useEffect, useRef, useCallback } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Checkbox,
  Select,
  InputNumber,
  Row,
  Popconfirm,
  Steps,
  Divider,
  message,
  Segmented,
  ConfigProvider,
} from "antd";
import { EnvironmentFilled, LoadingOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { getAllAreas } from "../Actions/areasAction";
import { getClients } from "../Actions/clientActions";
import { getAllTasks, deleteTask } from "../Actions/tasksAction";
import {
  getAllProperties,
  createPropery,
  publishedProperty,
  deletePropery,
} from "../Actions/propertiesActions";
import MyTable from "../components/table";
import "./styles/clients.css";
import { UpdateRentCommercialProperties } from "./UpdateRentCommercialProperties";
import { CreateTask } from "../pages/tasks";
import { ViewProperty } from "../pages/viewProperty";
import { PermissionWrapper } from "../components/PermissionWrapper";
import moment from "moment";
import _, { debounce } from "lodash";

import { CSVLink, CSVDownload } from "react-csv";
import useResizeObserver from "../components/useResizeObserver";
import useColumnSearch from "../Utils/useColumnSearch";
const PropertyType = [
  { value: 8, label: "Office" },
  { value: 9, label: "Shop" },
  { value: 10, label: "Showroom" },
  { value: 11, label: "Godown" },
  { value: 12, label: "Wear House" },
  { value: 17, label: "Redevelopment" },
];
const PropertyStatus = [
  { value: 0, label: "Available" },
  { value: 1, label: "Sold Out" },
  { value: 2, label: "On hold" },
  { value: 3, label: "Rented" },
];
const ClientType = [
  { value: 0, label: "Buyer" },
  { value: 1, label: "Seller" },
  { value: 2, label: "Rent Owner" },
  { value: 3, label: "Rent Client" },
];
const { Step } = Steps;
const steps = [
  {
    title: "Personal Details",
  },
  {
    title: "Property Details",
  },
];
const schema = Yup.object().shape({
  name: Yup.string().required("Required"),
  type_of_client: Yup.string().required("Required"),
  mobile_number: Yup.string().required("Required"),
  area_id: Yup.string().required("Required"),
  property_type: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Required"),
  cost: Yup.string().required("Required"),
});
const { TextArea } = Input;
const { Text, Title } = Typography;

const RentCommercialProperties = ({ currentUser }) => {
  const dispatch = useDispatch();
  const {
    clients,
    areas,
    properties,
    isGetPropertiesLoading,
    isCreatePropertyLoading,
    isUpdatePropertyLoading,
    isDeletePropertyLoading,
  } = useSelector((state) => {
    const {
      properties,
      isGetPropertiesLoading,
      isCreatePropertyLoading,
      isUpdatePropertyLoading,
      isDeletePropertyLoading,
    } = state.properties;
    const { clients } = state.clients;
    const { areas } = state.areas;
    return {
      clients,
      areas,
      properties,
      isGetPropertiesLoading,
      isCreatePropertyLoading,
      isUpdatePropertyLoading,
      isDeletePropertyLoading,
    };
  });
  const rentResProps = _.filter(properties, function (o) {
    return o.is_rent === true;
  });

  useEffect(() => {
    dispatch(getAllProperties("is_commercial"));
  }, []);
  useEffect(() => {
    dispatch(getClients());
  }, []);
  useEffect(() => {
    dispatch(getAllAreas());
  }, []);
  const {
    handleSubmit,
    errors,
    clearErrors,
    control,
    reset,
    getValues,
    trigger,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      is_fix: false,
      is_negotiable: false,
      inbound_property: false,
      available: false,
      is_web_visible: false,
      is_furnished: false,
      published: false,
      is_commercial: false,
      is_residential: false,
      is_plot: false,
      is_new: false,
      is_resell: false,
      is_rent: false,
      is_lease: false,
      fix_kitchen: false,
      mod_kitchen: false,
      fix_drawing_room: false,
      mod_drawing_room: false,
      fix_bedroom: false,
      mod_bedroom: false,
      electronics: false,
      pentry: false,
      attachable_washroom: false,
      air_condition: false,
      water_supply: false,
      water_24hr: false,
      png: false,
      security: false,
      cctv: false,
      lift: false,
      common_parking: false,
      paid_parking: false,
      garden: false,
      children_play_area: false,
      club_house: false,
      gymnasium: false,
      common_plot: false,
      religious_place: false,
      park_garden: false,
      educational_institute: false,
      hospital_dispansary: false,
      mall_market: false,
      bus_stop: false,
      type_of_client: null,
      name: "",
      mobile_number: "",
      area_id: null,
      property_type: null,
      cost: "",
      created_at: moment(new Date()),
    },
    mode: "all",
  });
  const mobileInput = watch("mobile_number") || "";
  const watching = watch(["is_furnished"]);
  const { is_furnished } = watching;
  const [createDialog, setCreateDialog] = useState(false);
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [vastuValue, setVastuValue] = useState("Yes");
  const [current, setCurrent] = React.useState(0);

  useEffect(() => {
    if (mobileInput && mobileInput.length === 10) {
      const matchedClient = clients.find(
        (client) => client.mobile_number === mobileInput,
      );

      if (matchedClient) {
        setValue("name", matchedClient.name || "");
        setValue("type_of_client", matchedClient.client_type || "");
      } else {
        setValue("name", "");
        setValue("type_of_client", "");
      }
    } else {
      setValue("name", "");
      setValue("type_of_client", "");
    }
  }, [mobileInput, clients, setValue]);

  const next = () => {
    const {
      name: clientName,
      type_of_client: type_of_client,
      mobile_number: mobileNumber,
      area_id: aid,
      property_type: PT,
      cost: cst,
    } = getValues([
      "name",
      "type_of_client",
      "mobile_number",
      "area_id",
      "property_type",
      "cost",
    ]);
    if (
      current === 0 &&
      (!clientName ||
        type_of_client === undefined ||
        type_of_client === null ||
        !mobileNumber ||
        !aid ||
        !PT)
    ) {
      trigger([
        "name",
        "type_of_client",
        "mobile_number",
        "area_id",
        "property_type",
      ]);
    } else if (current === 1 && !cst) {
      trigger(["cost"]);
    } else {
      setCurrent(current + 1);
    }
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const handleCreatePropery = (data, event) => {
    data.is_commercial = true;
    data.vastu_complient = vastuValue === "Yes" ? 0 : 1;
    dispatch(
      createPropery(
        data,
        "is_commercial",
        successCreateRentCommercialProperty,
        failureCreateRentCommercialProperty,
        // IsEmpty
      ),
    );
  };
  const successCreateRentCommercialProperty = () => {
    setCreateDialog(false);
    setCurrent(0);
    reset();
    dispatch(getClients());
    setTimeout(() => {
      message.success("You have successfully create rent commercial property.");
    }, 2000);
  };
  const failureCreateRentCommercialProperty = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
    setCreateDialog(false);
    setCurrent(0);
    reset();
  };
  const handleCancel = () => {
    setCreateDialog(false);
    setCurrent(0);
    reset({
      name: null,
      type_of_client: null,
      mobile_number: null,
      area_id: null,
      property_type: null,
      cost: null,
    });
    clearErrors();
  };

  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== size.width || newHeight !== size.height) {
        setSize({ width: newWidth, height: newHeight });
      }
    }, 200),
    [size],
  );
  useResizeObserver(handleResize);

  return (
    <Spin
      spinning={
        isGetPropertiesLoading ||
        isCreatePropertyLoading ||
        isUpdatePropertyLoading ||
        isDeletePropertyLoading
      }
    >
      <Modal
        title="Create Rent Commercial Property"
        visible={createDialog}
        onCancel={() => handleCancel()}
        footer={null}
        width={800}
        maskClosable={false}
      >
        <Row>
          <Steps
            current={current}
            size="small"
            responsive="true"
            labelPlacement="vertical"
          >
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </Row>
        <form onSubmit={handleSubmit(handleCreatePropery)}>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Client name</Text>
              </Row>
              <Controller
                as={Input}
                name="name"
                control={control}
                placeholder="Enter client name"
              />
              {errors.name && (
                <span className="error_style">Client name is required</span>
              )}
            </Col>
            <Col
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
              style={{ display: current === 0 ? "block" : "none" }}
            >
              <Row>
                <Text>Client Type</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={ClientType}
                style={{ width: "100%" }}
                name="type_of_client"
              />
              {errors.type_of_client && (
                <span className="error_style">Client Type is required</span>
              )}
            </Col>
            <Col
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
              style={{ display: current === 0 ? "block" : "none" }}
            >
              <Row>
                <Text>Client Mobile number</Text>
              </Row>
              <Controller
                name="mobile_number"
                control={control}
                rules={{ required: true, minLength: 10, maxLength: 10 }}
                render={({ value, onChange }) => (
                  <Input
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    maxLength={10}
                    placeholder="Enter mobile number"
                  />
                )}
              />
              {errors.mobile_number && (
                <span className="error_style">Mobile number is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Property Type</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={PropertyType}
                name="property_type"
                style={{ width: "100%" }}
              />
              {errors.property_type && (
                <span className="error_style">Property Type is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Entry Date</Text>
              </Row>
              <Controller
                as={Input}
                name="created_at"
                control={control}
                placeholder="Entry Date"
                type="date"
                format="DD-MM-YYYY"
                // defaultValue={new Date()}
              />
              {errors.created_at && (
                <span className="error_style">Entry Date is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Office/Shop/Godown No.</Text>
              </Row>
              <Controller
                as={Input}
                name="unique_number"
                control={control}
                placeholder="Office/Shop/Godown No."
              />
              {errors.unique_number && (
                <span className="error_style">
                  Office/Shop/Godown No is required
                </span>
              )}
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>

            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={16}
              lg={16}
              md={16}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Address</Text>
              </Row>
              <Controller
                as={Input}
                name="address"
                control={control}
                placeholder="Address"
              />
              {errors.unique_number && (
                <span className="error_style">Address is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Landmark</Text>
              </Row>
              <Controller
                as={Input}
                name="landmark"
                control={control}
                placeholder="Landmark"
              />
              {errors.landmark && (
                <span className="error_style">Landmark is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>

            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Area</Text>
              </Row>
              <Controller
                as={Select}
                showSearch
                control={control}
                options={
                  areas &&
                  areas.length > 0 &&
                  areas.map((val, index) => {
                    return { label: val.name, value: val.id };
                  })
                }
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: "100%" }}
                name="area_id"
              />
              {errors.area_id && (
                <span className="error_style">Area is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Google Link</Text>
              </Row>
              <Controller
                as={Input}
                name="google_link"
                control={control}
                placeholder="City"
              />
              {errors.google_link && (
                <span className="error_style">City is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Property Status</Text>
              </Row>
              <Controller
                as={Select}
                control={control}
                options={PropertyStatus}
                name="property_status"
                style={{ width: "100%" }}
              />
              {errors.property_status && (
                <span className="error_style">Property Status is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>

            <Col
              style={{ display: current === 0 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Last Communication Date</Text>
              </Row>
              <Controller
                as={Input}
                name="last_communication_date"
                control={control}
                placeholder="Last Communication Date"
                type="date"
                format="DD-MM-YYYY"
                // defaultValue={new Date()}
              />
              {errors.created_at && (
                <span className="error_style">
                  Last Communication Date is required
                </span>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Area</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Super Builtup Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[super_builtup_area_sqFt]"
                type="number"
                control={control}
                placeholder="Super Builtup Area SqFt"
              />
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Less %</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[less_sqFt]"
                type="number"
                control={control}
                placeholder="Less %"
              />
            </Col>
            {/* <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Builtup Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[builtup_area_sqFt]"
                type="number"
                control={control}
                placeholder="Builtup Area SqFt"
              />
            </Col> */}
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Carpet Area SqFt</Text>
              </Row>
              <Controller
                as={Input}
                name="property_area_attributes[carpet_area_sqFt]"
                type="number"
                control={control}
                placeholder="Carpet Area SqFt"
              />
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Floor</Text>
              </Row>
              <Controller
                as={Input}
                name="floor"
                control={control}
                placeholder="Floor"
                type="number"
              />
              {errors.floor && (
                <span className="error_style">Floor is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Total Floor</Text>
              </Row>
              <Controller
                as={Input}
                name="total_floor"
                control={control}
                placeholder="Total Floor"
                type="number"
              />
              {errors.total_floor && (
                <span className="error_style">Total Floor is required</span>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Cost</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            {/* <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Price per Sqft</Text>
              </Row>
              <Controller
                name="cost_one"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    {...props}
                  />
                )}
              />
              {errors.cost_one && (
                <span className="error_style">Price per Sqft is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Extra per Sqft </Text>
              </Row>
              <Controller
                name="cost_two"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    {...props}
                  />
                )}
              />
              {errors.cost_two && (
                <span className="error_style">Extra per Sqft is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Total Cost </Text>
              </Row>
              <Controller
                name="cost"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    {...props}
                  />
                )}
              />
              {errors.cost && (
                <span className="error_style">Total Cost  is required</span>
              )}
            </Col> */}
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>No of Deposite</Text>
              </Row>
              <Controller
                name="cost_two"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost_two && (
                <span className="error_style">No of Deposite is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Maintenance</Text>
              </Row>
              <Controller
                name="cost_three"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost_three && (
                <span className="error_style">Maintenance is required</span>
              )}
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Total Rent </Text>
              </Row>
              <Controller
                name="cost"
                control={control}
                render={(props) => (
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) =>
                      value
                        ? `₹ ${new Intl.NumberFormat("en-IN").format(value)}`
                        : "₹ "
                    }
                    parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                    {...props}
                  />
                )}
              />
              {errors.cost && (
                <span className="error_style">Total Rent is required</span>
              )}
            </Col>
          </Row>
          <Divider />
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Facing</Text>
              </Row>
              <Controller
                as={Input}
                name="facing"
                control={control}
                placeholder="Facing"
              />
              {errors.facing && (
                <span className="error_style">Facing is required</span>
              )}
            </Col>
            {/* <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Vastu Complient</Text>
              </Row>
              <Controller
                as={Input}
                name="vastu_complient"
                control={control}
                placeholder="Vastu Complient"
                type="number"
              />
              {errors.vastu_complient && (
                <span className="error_style">Vastu Complient is required</span>
              )}
            </Col> */}
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Typography>Vastu Compliance</Typography>
              <ConfigProvider
                theme={{
                  components: {
                    Segmented: {
                      itemActiveBg: "none",
                      itemColor: "none",
                      itemSelectedBg: "#c0cdf2",
                      itemSelectedColor: "#000",
                      itemHoverBg: "none",
                      itemHoverColor: "none",
                    },
                  },
                }}
              >
                <Segmented
                  options={["Yes", "No"]}
                  value={vastuValue}
                  onChange={setVastuValue}
                  block
                  className="segmentedForm"
                />
              </ConfigProvider>

              {errors.vastu_complient && (
                <span className="error_style">Vastu Complient is required</span>
              )}
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Construction Year</Text>
              </Row>
              <Controller
                as={Input}
                name="construction_year"
                control={control}
                placeholder="Construction Year"
                type="date"
              />
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={6}
              lg={6}
              md={6}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>Visit Time</Text>
              </Row>
              <Controller
                as={Input}
                name="visit_time"
                control={control}
                placeholder="Visit Time"
                type="time"
              />
              {errors.visit_time && (
                <span className="error_style">Visit Time is required</span>
              )}
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Agreement Date</Text>
              </Row>
              <Controller
                as={Input}
                name="agreement_date"
                type="date"
                format="DD-MM-YYYY"
                control={control}
                placeholder="Agreement Date"
              />
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row>
                <Text>Renewal Date</Text>
              </Row>
              <Controller
                as={Input}
                name="renewal_date"
                type="date"
                control={control}
                placeholder="Renewal Date"
              />
            </Col>

            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Row>
                <Text>About Key</Text>
              </Row>
              <Controller
                as={Input}
                name="about_key"
                control={control}
                placeholder="About Key"
              />
              {errors.about_key && (
                <span className="error_style">About Key is required</span>
              )}
            </Col>
          </Row>

          <Row gutter={[0, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>New</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_new"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Resell</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_resell"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Rent</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_rent"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Lease</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_lease"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{ display: current === 1 ? "block" : "none" }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="notes_box"
            >
              <Row>
                <Text>Details</Text>
              </Row>
              <Controller
                as={TextArea}
                name="details"
                control={control}
                rows={4}
                showCount
                maxLength={100}
              />
              {errors.details && (
                <span className="error_style">Details is required</span>
              )}
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Furniture</Divider>
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Furnished</Text>
                </Col>
                <Col>
                  <Controller
                    name="is_furnished"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Electronics</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[electronics]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Pentry</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[pentry]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Attachable Washroom</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[attachable_washroom]"
                    control={control}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display:
                  current === 1 && is_furnished === true ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Air Condition</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_furniture_attributes[air_condition]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Amenity</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Water Supply</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[water_supply]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Water 24hr</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[water_24hr]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Png</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[png]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Security</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[security]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>cctv</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[cctv]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            {/* </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col> */}
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Lift</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[lift]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Common Parking</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[common_parking]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Paid parking</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[paid_parking]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Common Plot</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_amenity_attributes[common_plot]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
            >
              <Divider plain>Property Nearby</Divider>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Religious Place</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[religious_place]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Park Garden</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[park_garden]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Educational Institute</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[educational_institute]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[8, 16]}>
            <Col span={24}></Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Hospital/Dispansary</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[hospital_dispansary]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Mall/market</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[mall_market]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            <Col
              style={{
                display: current === 1 ? "block" : "none",
              }}
              xl={8}
              lg={8}
              md={8}
              sm={12}
              xs={12}
            >
              <Row gutter={[8, 0]}>
                <Col>
                  <Text>Bus Stop</Text>
                </Col>
                <Col>
                  <Controller
                    name="property_nearby_attributes[bus_stop]"
                    control={control}
                    defaultValue={false}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        checked={props.value}
                        onChange={(e) => props.onChange(e.target.checked)}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row justify="end" gutter={[8, 16]}>
            <Col span={24}></Col>
            {!isCreatePropertyLoading && current > 0 && (
              <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" onClick={() => next()}>
                Next
              </Button>
            )}

            {current === steps.length - 1 && (
              <>
                {isCreatePropertyLoading ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                ) : (
                  <Button type="primary" htmlType="submit">
                    Create
                  </Button>
                )}
              </>
            )}
          </Row>
        </form>
      </Modal>
      {rentResProps && (
        <AllCommercialProperties
          data={rentResProps}
          handleDialog={() => setCreateDialog(true)}
          currentUser={currentUser}
        />
      )}
    </Spin>
  );
};
export default RentCommercialProperties;

const AllCommercialProperties = (props) => {
  const { getColumnSearchProps } = useColumnSearch();
  const dispatch = useDispatch();
  const { areas } = useSelector((state) => state.areas);
  const { clients } = useSelector((state) => state.clients);
  const { tasks, isGetTasksLoading } = useSelector((state) => state.tasks);
  const { users } = useSelector((state) => state.users);
  const { handleDialog, currentUser } = props;
  const [showTask, setShowTask] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [currentProperty, setCurrentProperty] = useState({});

  const onRowSelect = (record) => {
    setCurrentProperty(record);
    setShowSearch(true);
    setShowTask(true);
  };
  const onTaskRowClick = (task) => {};
  // useEffect(() => {
  //   if (createPropery !== {}) {
  //   }
  // }, [currentProperty]);

  useEffect(() => {
    if (currentProperty && Object.keys(currentProperty).length > 0) {
      dispatch(getAllTasks(currentProperty.id));
    }
  }, [currentProperty, dispatch]);

  const headers = [
    { label: "Area", key: "area.name" },
    { label: "Property", key: "property_type" },
    { label: "Address", key: "address" },
    { label: "Property No.", key: "unique_number" },
    {
      label: "Super Buildup",
      key: "property_area_attributes.super_builtup_area_sqFt",
    },
    { label: "Less %", key: "property_area_attributes.less_sqFt" },
    {
      label: "Carpet Area Sqft",
      key: "property_area_attributes.carpet_area_sqFt",
    },
    // { label: "Price per Sqft", key: "cost_one",},
    { label: "Maintenance", key: "cost_two" },
    { label: "Total Rent", key: "cost" },
    { label: "Map", key: "google_link" },
    ...(currentUser.role === "Admin"
      ? [{ label: "Client Name", key: "client_name" }]
      : []),
    { label: "Entry Date", key: "created_at" },
    { label: "Chat", key: "last_communication_date" },
    { label: "Property Status", key: "property_status" },
    { label: "Agreement Date", key: "agreement_date" },
    { label: "Renewal Date", key: "renewal_date" },
  ];
  const columns = (areas, clients) => [
    {
      title: "Area",
      dataIndex: "area",
      key: "1",
      width: 100,
      fixed: "left",
      render: (record, object) => {
        return <div>{record.name}</div>;
      },
      filters:
        areas &&
        areas.length > 0 &&
        areas.map((area, index) => {
          return { text: area.name, value: area.name };
        }),
      onFilter: (value, record) => {
        return record.area.name.indexOf(value) === 0;
      },
    },
    {
      title: "Property",
      dataIndex: "property_type",
      key: "2",
      width: 100,
      // ...getColumnSearchProps("property_type"),
      filters: [
        {
          text: "Office",
          value: "Office",
        },
        {
          text: "Shop",
          value: "Shop",
        },
        {
          text: "Showroom",
          value: "Showroom",
        },
        {
          text: "Godown",
          value: "Godown",
        },
        {
          text: "Wear House",
          value: "Wear House",
        },
        {
          text: "Redevelopment",
          value: "Redevelopment",
        },
      ],
      onFilter: (value, object, record) => {
        return object.property_type.indexOf(value) === 0;
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "3",
      width: 100,
    },
    {
      title: "Property No.",
      dataIndex: "unique_number",
      key: "4",
      width: 100,
    },
    {
      title: "Super Buildup ",
      dataIndex: "property_area_attributes",
      key: "5",
      width: 100,
      render: (record, object) => {
        return <>{record ? record.super_builtup_area_sqFt : ""}</>;
      },
      sorter: (a, b) => a.floor - b.floor,
    },
    // {
    //   title: "Less SqFt",
    //   dataIndex: "property_area_attributes",
    //   key: "5",
    //   width: '20%',
    //   render: (record, object) => {
    //     return <>{record ? record.less_sqFt : ""}</>;
    //   },
    //   sorter: (a, b) => a.floor - b.floor,
    // },
    {
      title: "Less %",
      dataIndex: "property_area_attributes",
      key: "6",
      width: 80,
      render: (record, object) => {
        return <>{record ? record.less_sqFt : ""}</>;
      },
      sorter: (a, b) => a.less_sqFt - b.less_sqFt,
    },
    {
      title: "Carpet",
      dataIndex: "property_area_attributes",
      key: "7",
      width: 80,
      render: (record, object) => {
        return <>{record ? record.carpet_area_sqFt : ""}</>;
      },
      sorter: (a, b) => a.floor - b.floor,
    },
    {
      title: "Price per Sqft",
      dataIndex: "cost_one",
      key: "8",
      width: 100,
      render: (cost_one) => {
        if (cost_one == null) return null;
        const formattedCost = new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 0,
        }).format(cost_one);

        return <div>{formattedCost.replace("₹", "₹ ")}</div>;
      },
      sorter: (a, b) => a.cost_one - b.cost_one,
    },
    {
      title: "Maintenance",
      dataIndex: "cost_two",
      key: "9",
      width: 100,
      render: (cost_two) => {
        if (cost_two == null) return null;
        const formattedCost = new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 0,
        }).format(cost_two);

        return <div>{formattedCost.replace("₹", "₹ ")}</div>;
      },
      sorter: (a, b) => a.cost_two - b.cost_two,
    },
    {
      title: "Total Rent",
      dataIndex: "cost",
      key: "10",
      width: 100,
      render: (cost) => {
        if (cost == null) return null;
        const formattedCost = new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 0,
        }).format(cost);

        return <div>{formattedCost.replace("₹", "₹ ")}</div>;
      },
      sorter: (a, b) => a.cost - b.cost,
    },
    {
      title: "Total (Words)",
      dataIndex: "cost",
      key: "total_in_words",
      width: 100,
      render: (cost) => {
        if (cost == null || isNaN(cost) || cost === "") return "-";
        const num = Number(cost);
        if (num >= 10000000) {
          const crValue = num / 10000000;
          const truncated =
            Math.floor(Math.round(crValue * 1000000) / 10000) / 100;
          return <div>{`₹ ${truncated} Cr`}</div>;
        } else if (num >= 100000) {
          const lakhValue = num / 100000;
          const truncated =
            Math.floor(Math.round(lakhValue * 1000000) / 10000) / 100;
          return <div>{`₹ ${truncated} L`}</div>;
        } else {
          return (
            <div>
              {new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                maximumFractionDigits: 0,
              })
                .format(num)
                .replace("₹", "₹ ")}
            </div>
          );
        }
      },
      sorter: (a, b) => a.cost - b.cost,
    },
    {
      title: "Map",
      dataIndex: "google_link",
      key: "11",
      width: 60,
      render: (id) => (
        <Button type="link" href={id} target="_blank">
          <EnvironmentFilled></EnvironmentFilled>
        </Button>
      ),
    },
    ...(currentUser?.role === "Admin"
      ? [
          {
            title: "Client Name",
            dataIndex: "client_name",
            key: "16",
            width: 100,
            ...getColumnSearchProps("client_name"),
            render: (record) => (
              <Typography className="propertyText">{record}</Typography>
            ),
          },
        ]
      : []),
    {
      title: "Entry Date",
      dataIndex: "created_at",
      key: "13",
      width: 100,
      sorter: (a, b) => a.created_at - b.created_at,
      render: (created_at) => {
        if (!created_at) return "-";
        const formattedDate = moment(created_at, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
    },
    {
      title: "Chat",
      dataIndex: "last_communication_date",
      key: "14",
      width: 100,
      render: (last_communication_date) => {
        if (!last_communication_date) return "-";
        const formattedDate = moment(last_communication_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
      // sorter: (a, b) => a.last_communication_date - b.last_communication_date,
    },
    {
      title: "Property Status",
      dataIndex: "property_status",
      key: "15",
      width: 100,
      render: (record) => {
        return <>{record ? record : ""}</>;
      },
    },
    {
      title: "Agreement Date",
      dataIndex: "agreement_date",
      key: "16",
      width: 120,
      render: (agreement_date) => {
        if (!agreement_date) return "-";
        const formattedDate = moment(agreement_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
      // sorter: (a, b) => a.agreement_date - b.agreement_date,
    },
    {
      title: "Renewal Date",
      dataIndex: "renewal_date",
      key: "17",
      width: 100,
      render: (renewal_date) => {
        if (!renewal_date) return "-";
        const formattedDate = moment(renewal_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
      // sorter: (a, b) => a.renewal_date - b.renewal_date,
    },
    {
      title: "id",
      width: 100,
      dataIndex: "id",
      key: "18",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <ActionComponent
          id={id}
          published={currentProperty.published}
          type="is_commercial"
          currentUser={currentUser}
        />
      ),
    },
  ];

  const Taskcolumns = (users) => [
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "7",
      width: 150,
      ...getColumnSearchProps("user_name"),
      render: (record, object) => {
        return <Button type="link">{record}</Button>;
      },
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      width: 100,
      sorter: (a, b) => a.due_date - b.due_date,
    },
    {
      title: "Communcation Date",
      dataIndex: "communication_date",
      key: "communication_date",
      width: 130,
      sorter: (a, b) => a.communication_date - b.communication_date,
      render: (communication_date) => {
        return <div>{communication_date || "-"}</div>;
      },
    },
    {
      title: "Follow up Date",
      dataIndex: "follow_up_date",
      key: "follow_up_date",
      width: 130,
      sorter: (a, b) => a.follow_up_date - b.follow_up_date,
      render: (follow_up_date) => {
        return <div>{follow_up_date || "-"}</div>;
      },
    },
    {
      title: "Site visit Date",
      dataIndex: "site_visit_date",
      key: "site_visit_date",
      width: 100,
      sorter: (a, b) => a.site_visit_date - b.site_visit_date,
      render: (site_visit_date) => {
        return <div>{site_visit_date || "-"}</div>;
      },
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 100,
      filters: [
        {
          text: "note",
          value: "note",
        },
      ],
      onFilter: (value, record) => record.note.indexOf(value) === 0,
    },
    {
      title: "id",
      width: 100,
      dataIndex: "id",
      key: "21",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id) => (
        <TaskActionComponent id={id} currentProperty={currentProperty} />
      ),
    },
  ];
  return (
    <>
      <Row className="rowWithPadding" justify="space-between">
        <Col>
          <Title level={4}>
            All Rent Commercial Properties({props.data.length})
          </Title>
        </Col>
        <Col>
          <Row gutter={[16, 0]} align="middle">
            <Col>
              <CSVLink
                data={props.data}
                headers={headers}
                filename={`commercial_${new Date().toISOString()}.csv`}
              >
                Download
              </CSVLink>
            </Col>
            <Col>
              <PermissionWrapper resource="properties_rent_commercial" action="create" disabled={true}>
                <Button type="primary" onClick={() => handleDialog()}>
                  Create Rent Commercial Property
                </Button>
              </PermissionWrapper>
            </Col>
          </Row>
        </Col>
      </Row>
      <MyTable
        columns={columns(areas, clients)}
        data={props.data}
        onRowSelect={(record) => onRowSelect(record)}
        rowClassName={(record) =>
          record.property_status === "Onhold" ? "onHoldRow" : ""
        }
      />
      {showSearch && showTask && (
        <>
          <Row>
            <Col span={24}>
              <Row className="rowWithPadding" justify="space-between">
                <Col>
                  <Title level={4}>Task({tasks.length})</Title>
                </Col>
              </Row>
              <Spin spinning={isGetTasksLoading}>
                <MyTable
                  columns={Taskcolumns(users)}
                  data={tasks}
                  onRowSelect={(record) => onTaskRowClick(record)}
                />
              </Spin>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
const ActionComponent = ({ id, published, type, currentUser }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const dispatch = useDispatch();
  const [createDialog, setCreateDialog] = useState(false);
  const [current, setCurrent] = React.useState(0);

  const { properties } = useSelector((state) => state.properties);
  const property = properties?.find((p) => p.id === id);
  const isOwner = property?.user_id === currentUser?.id;

  const handleUpdatePublished = () => {
    setPopoverVisible(false);
    dispatch(publishedProperty(id, true, type));
  };
  const handleDeleteRentCommercial = (property_id, type) => {
    property_id = id;
    dispatch(
      deletePropery(
        property_id,
        "is_commercial",
        successDeleteRentCommercialProperty,
        failureDeleteRentCommercialProperty,
      ),
    );
  };
  const successDeleteRentCommercialProperty = () => {
    setTimeout(() => {
      message.success("You have successfully delete rent commercial property.");
    }, 2000);
  };
  const failureDeleteRentCommercialProperty = () => {
    setTimeout(() => {
      message.info("Something went wrong.");
    }, 2000);
  };
  const handleUpdateUnPublished = () => {
    setPopoverVisible(false);
    dispatch(publishedProperty(id, false, type));
  };
  const content = (
    <div>
      <PermissionWrapper resource="tasks" action="create" disabled={true}>
        <CreateTask
          attachment_id={id}
          attachment_type="Property"
          setPopoverVisible={setPopoverVisible}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper resource="properties_rent_commercial" action="show" disabled={true} bypass={isOwner}>
        <ViewProperty
          id={id}
          setPopoverVisible={setPopoverVisible}
          currentUser={currentUser}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      <PermissionWrapper resource="properties_rent_commercial" action="update" disabled={true} bypass={isOwner}>
        <UpdateRentCommercialProperties
          id={id}
          setPopoverVisible={setPopoverVisible}
          currentUser={currentUser}
        />
      </PermissionWrapper>
      &nbsp;&nbsp;
      {published ? (
        <PermissionWrapper resource="properties_rent_commercial" action="update" disabled={true} bypass={isOwner}>
          <Button type="link" onClick={() => handleUpdateUnPublished()}>
            Un Published
          </Button>
        </PermissionWrapper>
      ) : (
        <PermissionWrapper resource="properties_rent_commercial" action="update" disabled={true} bypass={isOwner}>
          <Button type="link" onClick={() => handleUpdatePublished()}>
            Published
          </Button>
        </PermissionWrapper>
      )}
      <PermissionWrapper resource="properties_rent_commercial" action="destroy" disabled={true}>
        <Popconfirm
          title="Sure to delete?"
          // onConfirm={() => dispatch(deletePropery(id, type))}
          onConfirm={() => handleDeleteRentCommercial(id, type)}
        >
          <Button type="link" onClick={() => setPopoverVisible(false)}>
            Delete
          </Button>
        </Popconfirm>
      </PermissionWrapper>
    </div>
  );
  return (
    <Popover
      content={content}
      open={popoverVisible}
      trigger="click"
      onOpenChange={setPopoverVisible}
    >
      <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
        Action
      </Button>
    </Popover>
  );
};

const TaskActionComponent = ({ id, currentProperty }) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const dispatch = useDispatch();
  const content = (
    <div>
      <Popconfirm
        title="Sure to delete?"
        onConfirm={() =>
          dispatch(deleteTask(id, { attachment_id: currentProperty.id }))
        }
      >
        <Button type="link" onClick={() => setPopoverVisible(false)}>
          Delete
        </Button>
      </Popconfirm>
    </div>
  );
  return (
    <Popover
      content={content}
      open={popoverVisible}
      trigger="click"
      onOpenChange={setPopoverVisible}
    >
      <Button type="link" onClick={() => setPopoverVisible(!popoverVisible)}>
        Action
      </Button>
    </Popover>
  );
};
